/**
 * Determines the secondary message to display for an order status.
 * @param orderStatus - The order status to evaluate
 * @param timestamp - The formatted timestamp string to use for history orders
 * @returns The appropriate secondaryMessage value for OrderStatusDisplay component
 */
export function getOrderSecondaryMessage(
  orderStatus: string,
  timestamp?: string,
): string | undefined {
  // For history views - completed statuses should show timestamps
  if (['Completed', 'Fulfilled', 'Cancelled'].includes(orderStatus))
    return timestamp

  // For OnTheWay and TempoOnTheWay status, show "Prepare Order" instead of timestamp
  if (orderStatus === 'OnTheWay' || orderStatus === 'TempoOnTheWay')
    return 'Prepare Order'

  // All other active statuses don't show a secondary message
  return undefined
}
